import "./PrivacyTerms.css";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <div className="privacy" dir={localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"}>
        <h1>{t("terms_title")}</h1>
        <p>
          <strong>{t("terms_last_updated")}</strong>
        </p>

        <h2>{t("terms_introduction_title")}</h2>
        <p>{t("terms_introduction_text")}</p>

        <h2>{t("terms_acceptance_title")}</h2>
        <p>{t("terms_acceptance_text")}</p>

        <h2>{t("terms_changes_title")}</h2>
        <p>{t("terms_changes_text")}</p>

        <h2>{t("terms_registration_title")}</h2>
        <p>{t("terms_registration_text")}</p>

        <h2>{t("terms_conduct_title")}</h2>
        <p>{t("terms_conduct_text")}</p>
        <ul>
          <li>{t("terms_conduct_item1")}</li>
          <li>{t("terms_conduct_item2")}</li>
          <li>{t("terms_conduct_item3")}</li>
          <li>{t("terms_conduct_item4")}</li>
        </ul>

        <h2>{t("terms_intellectual_title")}</h2>
        <p>{t("terms_intellectual_text")}</p>

        <h2>{t("terms_fees_title")}</h2>
        <p>{t("terms_fees_text")}</p>

        <h2>{t("terms_privacy_title")}</h2>
        <p>{t("terms_privacy_text")}</p>

        <h2>{t("terms_liability_title")}</h2>
        <p>{t("terms_liability_text")}</p>

        <h2>{t("terms_termination_title")}</h2>
        <p>{t("terms_termination_text")}</p>
      </div>
    </div>
  );
};

export default Terms;
